export default __webpack_public_path__ + "static/media/image1.ead31b03.jpg";